import React from 'react';
import Calendar from '../layout/Calendar';

const AdminDashboardMain = () => {

  return (
    <div className='pattern-bg' style={{minHeight: '100vh'}}>
      <div className="container">
        <div className='row'>
          <div className='col'>
            <p className="lead"><i className='fa-light fa-user' /> Welcome Admin</p>
          </div>
          <div className='col'>
            <Calendar />
          </div>
        </div>
      </div>
    </div>
  )
};

export default AdminDashboardMain;